import { ref, computed } from 'vue';

export const STORAGE_KEY_BOOKMARKS = 'infoker_bookmarks';
const MAX_BOOKMARKS = 50;

export const bookmarks = ref([]);

const loadBookmarks = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY_BOOKMARKS);
    if (stored) {
      bookmarks.value = JSON.parse(stored);
    }
  } catch {
    bookmarks.value = [];
  }
};

const saveBookmarks = () => {
  try {
    localStorage.setItem(STORAGE_KEY_BOOKMARKS, JSON.stringify(bookmarks.value));
  } catch {
    // silent fail
  }
};

loadBookmarks();

export function useBookmarks() {
  const bookmarkCount = computed(() => bookmarks.value.length);

  const isBookmarked = (jobId) => {
    return bookmarks.value.some((b) => b.id === jobId);
  };

  const toggleBookmark = (job) => {
    const index = bookmarks.value.findIndex((b) => b.id === job.id);

    if (index !== -1) {
      bookmarks.value.splice(index, 1);
    } else {
      if (bookmarks.value.length >= MAX_BOOKMARKS) {
        bookmarks.value.pop();
      }
      bookmarks.value.unshift({
        id: job.id,
        bookmarked_at: new Date().toISOString(),
      });
    }
    saveBookmarks();
  };

  const removeBookmark = (jobId) => {
    const index = bookmarks.value.findIndex((b) => b.id === jobId);
    if (index !== -1) {
      bookmarks.value.splice(index, 1);
      saveBookmarks();
    }
  };

  const clearAllBookmarks = () => {
    bookmarks.value = [];
    saveBookmarks();
  };

  return {
    bookmarks,
    bookmarkCount,
    isBookmarked,
    toggleBookmark,
    removeBookmark,
    clearAllBookmarks,
    maxBookmarks: MAX_BOOKMARKS,
  };
}
